/* 营销报告拨号 */
const state = {
  companyName: '',
  reportCalling: true,
  reportCallInfo: [{ contact: '' }],
  /* 添加线索跟近 */
  reportDialog: false
  // editClues:false
};
const getters = {
  getCompanyName: state => state.companyName,
  getReportCalling: state => state.reportCalling,
  getReportCallInfo: state => state.reportCallInfo,
  getReportDialog: state => state.reportDialog
};

const actions = {
  fetchCompanyName({ commit }, data) {
    commit('setCompanyName', data);
  },
  fetchReportCalling({ commit }, data) {
    commit('setReportCalling', data);
  },
  fetchReportCallInfo({ commit }, data) {
    commit('setReportCallInfo', data);
  },
  fetchReportDialog({ commit }, data) {
    commit('setReportDialog', data);
  }
};
const mutations = {
  setCompanyName(state, data) {
    state.companyName = data;
  },
  setReportCalling(state, data) {
    state.reportCalling = data;
  },
  setReportCallInfo(state, data) {
    state.reportCallInfo = data;
  },
  setReportDialog(state, data) {
    state.reportDialog = data ? true : false;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/report.js